import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/hackzurich2022-swissre-challenge/hackzurich2022-swissre-challenge/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`On Microsoft Learn, you’ll find a lot of free `}<span>{`Learning Paths`}</span>{` around Microsoft and Open Source technology.
Many of them are aligned with professional `}<a parentName="p" {...{
          "href": "https://docs.microsoft.com/en-us/certifications/browse/?ocid=AID3054426"
        }}>{`Certifications`}</a></p>
    </PageDescription>
    <img {...{
      "src": "https://docs.microsoft.com/en-us/windows/mixed-reality/discover/images/02_mixedrealityslashmixedreality.png?ocid=AID3054426",
      "alt": null
    }}></img>
    <h2>{`Azure Fundamentals`}</h2>
    <p>{`Not too familiar with `}<span>{`Microsoft Azure Cloud`}</span>{`?
Here’s how to get started with free learning paths.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/certifications/exams/az-900?tab=tab-learning-paths?ocid=AID3054426"
          }}>{`AZ 900 - Azure Fundamentals`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/certifications/azure-ai-fundamentals/?ocid=AID3054426"
          }}>{`AI 900 - Azure AI Fundamentals`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/develop/mixed-reality-cloud-services?ocid=AID3054426"
          }}>{`Azure Mixed Reality Cloud Services Overview`}</a></p>
        <p parentName="li">{`Azure Cloud provides some useful services for MR applications, such as
`}<a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/azure/remote-rendering/"
          }}>{`Azure Remote Rendering`}</a>{`, `}<a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/azure/spatial-anchors/?ocid=AID3054426"
          }}>{`Azure Spatial Anchors`}</a>{`
and `}<a parentName="p" {...{
            "href": "https://docs.microsoft.com/en-us/azure/object-anchors/?ocid=AID3054426"
          }}>{`Azure Object Anchors`}</a>{`.`}</p>
      </li>
    </ul>
    <h2>{`Microsoft Mixed Reality`}</h2>
    <p>{`Start here to learn the basic concepts and terminology, and how to pick a tech stack for Mixed Reality Development.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/learn/modules/intro-to-mixed-reality/?ocid=AID3054426"
        }}>{`Introduction to Mixed Reality`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/?ocid=AID3054426"
        }}>{`Mixed Reality Documentation Home Page`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/develop/development?ocid=AID3054426"
        }}>{`Introduction to Mixed Reality Development`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/develop/choosing-an-engine?ocid=AID3054426"
        }}>{`Choose your Engine`}</a></li>
    </ul>
    <h2>{`For C# developers (Windows)`}</h2>
    <p>{`If you plan to develop using .NET / C#, here are some learning paths and modules to get started. There are multiple ways to develop MR Apps on Windows using C#. `}<strong parentName="p">{`For beginners, we suggest to try out Unity`}</strong>{`, as it’s the most used tool with tons of learning resources and tools.`}</p>
    <ul>
      <li parentName="ul">{`Unity (Game-Engine, multi-platform support (Android, iOS, HL2, multiple VR-glasses…)`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/learn/modules/mixed-reality-toolkit-project-unity/?ocid=AID3054426"
            }}>{`Set up a Mixed Reality project in Unity with the Mixed Reality Toolkit`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/mrtk-unity/mrtk2/?view=mrtkunity-2022-05?ocid=AID3054426"
            }}>{`Docs: Mixed Reality Toolkit (MRTK) with Unity`}</a>{`: MRTK is a very powerful package for Unity, which contains easy to use UI components such as buttons, keyboards, textboxes, hologram interaction and much more. MRTK also supports multiple devices. This way developers only have to develop their application once and can deploy it to smartphones and MR/VR glasses.`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/learn/paths/build-mixed-reality-azure-digital-twins-unity/?ocid=AID3054426"
            }}>{`Build Mixed Reality digital twins with Azure Digital Twins and Unity`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/learn/modules/create-language-translator-mixed-reality-application-unity-azure-cognitive-services/?ocid=AID3054426"
            }}>{`Create a language translator application with Unity and Azure Cognitive Services.`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/learn/modules/render-model-azure-remote-rendering-unity/?ocid=AID3054426"
            }}>{`Render large models with Azure Remote Rendering`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://docs.microsoft.com/en-us/azure/spatial-anchors/"
            }}>{`Azure Spatial Anchors for spatial persistence`}</a>{`: If you want your app to be space-persistent (e.g. store a hologram’s location relative to a real world location across multiple sessions and devices) or you want an MR multi-player experience, take a look at ASA. We?ocid=AID3054426’re always happy to answer questions about ASA.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`StereoKit (A light-weight, UI-less way to develop MR apps): StereoKit allows you to have much faster development cycles than Unity. If your desired app generates all its content at runtime, StereoKit is a good choice to start! StereoKit comes with C# and C++ wrappers - whatever you prefer.`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://stereokit.net/"
            }}>{`StereoKit, a Unity-Less, code only way of developing MR apps`}</a></li>
        </ul>
      </li>
      <li parentName="ul">{`Unreal Engine`}
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "https://www.unrealengine.com/en-US/blog/learn-unreal-engine-for-microsoft-hololens-2"
            }}>{`Learn Unreal Engine for HL2 development`}</a></li>
        </ul>
      </li>
    </ul>
    <h2>{`For JavaScript/TypeScript developers`}</h2>
    <p>{`If you want to use JavaScript and WebXR, we recommend you start with the following resources.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/develop/javascript/webxr-overview?ocid=AID3054426"
        }}>{`WebXR development with JavaScript`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/develop/javascript/tutorials/babylonjs-webxr-helloworld/introduction-01?ocid=AID3054426"
        }}>{`Tutorial: Create your first WebXR application using Babylon.js`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/develop/javascript/tutorials/babylonjs-webxr-piano/introduction-01?ocid=AID3054426"
        }}>{`Tutorial: Build a piano in WebXR using Babylon.js`}</a></li>
    </ul>
    <h2>{`Unity resources`}</h2>
    <p>{`To get started in Extended Reality development with Unity, have a look at the following resources.`}</p>
    <p><a parentName="p" {...{
        "href": "https://unity.com/"
      }}>{`Build real-time 3D projects for various industries`}</a>{`
`}<a parentName="p" {...{
        "href": "https://learn.unity.com/"
      }}>{`Learn how to get started in Unity with on-demand learning content`}</a>{`
`}<a parentName="p" {...{
        "href": "https://www.youtube.com/playlist?list=PLX2vGYjWbI0Q1e0IIGsYro3SiE0chtRtc"
      }}>{`First Day in Unity Guide - Videos to get you started in Unity`}</a></p>
    <h2>{`Additional Resources (Microsoft Research)`}</h2>
    <p>{`Additional interesting material, e.g. from the `}<span>{`Mixed-Reality and AI Lab at ETH Zurich`}</span>{` For questions about this work, contact Eric or Patrick from the Microsoft Team on Discord.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.microsoft.com/en-us/research/blog/enabling-interaction-between-mixed-reality-and-robots-via-cloud-based-localization/"
        }}>{`https://www.microsoft.com/en-us/research/blog/enabling-interaction-between-mixed-reality-and-robots-via-cloud-based-localization/`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.microsoft.com/en-us/research/podcast/holograms-spatial-anchors-and-the-future-of-computer-vision-with-dr-marc-pollefeys/"
        }}>{`https://www.microsoft.com/en-us/research/podcast/holograms-spatial-anchors-and-the-future-of-computer-vision-with-dr-marc-pollefeys/`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      